import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { HttpBackendService } from '../http/http.backend-service';

export interface QrAuthSessionResponse {
  session_id: string;
  pin: string;
  status: 'pending' | 'authenticated' | 'expired' | 'cancelled';
  user?: any;
  session_token?: string;
}

@Injectable({
  providedIn: 'root',
})
export class QrAuthBackendService {
  private readonly BASE_ADDRESS = '/auth/qr';

  constructor(private http: HttpBackendService) {}

  public getSessionStatus(token: string): Promise<QrAuthSessionResponse> {
    return firstValueFrom(
      this.http.get<QrAuthSessionResponse>(
        `${this.BASE_ADDRESS}/${token}/info`,
        {
          withCredentials: true,
        }
      )
    );
  }

  public completeAuth(token: string, pinConfirmed: boolean): Promise<any> {
    return firstValueFrom(
      this.http.post<any>(
        `${this.BASE_ADDRESS}/complete`,
        {
          token: token,
          pinConfirmed: pinConfirmed,
        },
        {
          withCredentials: true,
        }
      )
    );
  }

  public cancelAuth(token: string): Promise<any> {
    return firstValueFrom(
      this.http.post<any>(`${this.BASE_ADDRESS}/cancel`, {
        token: token,
      })
    );
  }
}
